import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=e04f8b2c&scoped=true&"
import script from "./Research.vue?vue&type=script&lang=ts&"
export * from "./Research.vue?vue&type=script&lang=ts&"
import style0 from "./Research.vue?vue&type=style&index=0&id=e04f8b2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04f8b2c",
  null
  
)

export default component.exports